(ns teamoesterreich.admin-mode.data.userMessages
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))




(def TYPE_MAP {"sms"   "SMS"
               "email" "Email"
               "push"  "Push"
               })


(defn email-to-tomIds [tomIds subject email done-fn]
  (log/debug "email-to-list " tomIds subject)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-message/send-email-to-tomIds")
                   (ajax/serialize {:subject subject
                                    :message email
                                    :tomIds  tomIds})
                   (fn [r-list status]
                     (log/debug "email-to-list done" r-list status)
                     (when (= status 200)
                       (done-fn)))))

(defn sms-to-tomIds [tomIds message done-fn]
  (log/debug "sms-to-list " tomIds message)
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/user-message/send-sms-to-tomIds")
                   (ajax/serialize {:message message
                                    :tomIds  tomIds})
                   (fn [r-list status]
                     (log/debug "sms-to-list done" r-list status)
                     (when (= status 200)
                       (done-fn)))))



(defn get-user-messages [tomIds done-fn]
  (log/debug "get-user-messages " tomIds)
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user-message/toe/" tomIds)
                  (fn [r-list status]
                    (log/debug "get-user-messages done" status)
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "userMessage-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                        )))))

(defn get-messages [done-fn]
  (log/debug "get-messages ")
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/user-message")
                  (fn [r-list status]
                    (log/debug "get-messages done" status)
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] (let [d-userMessages (clojure.walk/keywordize-keys e)
                                                    d-userMessages (assoc d-userMessages
                                                                     :_userMessageType (get TYPE_MAP (:userMessage-type d-userMessages))
                                                                     :_user-lastName (get-in d-userMessages [:user :user-lastName])
                                                                     :_user-firstName (get-in d-userMessages [:user :user-firstName])
                                                                     :_organisationDepartment (get-in d-userMessages [:user :user-orgId])
                                                                     :_orgId (get-in d-userMessages [:user :user-orgId])
                                                                     )
                                                    ]
                                                [(:userMessage-uuid d-userMessages) d-userMessages]))
                                      (js->clj (json/parse r-list))))
                        )))))


